import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service';
import { CompaniasProvider } from '../../providers/companias/companias';
import { CargosProvider } from '../../providers/cargos/cargos';
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';
import { UsuarioSelectPage } from '../usuario-select/usuario-select';
import { Estados } from '../../models/estados/estados.models';
import * as fromEstados from './../meseromesero/state/estados/estados.accions'
import { AppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import * as fromUsuarioSelect from './../meseromesero/state/usuarioselect/usuarioselect.accions'
import { valueDisplay } from '../../models/valueDisplay.model';
import { entidades } from '../../models/entidades';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { UtilsProvider } from '../../providers/utils/utils';
import { EntidadesEditarPage } from '../entidades-editar/entidades-editar';

@IonicPage()
@Component({
  selector: 'page-entidades-generales',
  templateUrl: 'entidades-generales.html',
  providers: [ AuthService ]
})
export class EntidadesGeneralesPage {
  nombreEntidad:string = ""
  identificacion:string = ""
  entidades = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  estado: Estados =  {
    clienteSelect: false,
    usuarioSelect: true,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }  
  usuarioId = [];
  valoresUsuario: string = '';
  direccion:string = '';
  telefono:string = '';
  estados:string = '';
  contacto:string = '';
  constructor(    public navCtrl: NavController, public navParams: NavParams,
    public auth: AuthService,
    public servicioCompania:CompaniasProvider,
    public storages:Storage,
    public servicio: CargosProvider,
    private store: Store<AppState>,
    public modalControllers: ModalController,
    public servicioCliente:ClientesProvider,
    public utilidades:UtilsProvider,
    ) {


 
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
      if(val){
      this.nombreCompaniaHeader = val['nombreCompania']
      this.nombreCargoHeader = val['nombreCargo']
      }
      })
  }

  ionViewDidLoad() {
    this.cargarServicio()
  }

  cargarServicio() {
    this.storages.get('companiasId').then((val) => {
      this.servicio.buscarEntidadesPorEmpresa(val)
      .subscribe((data) => {
        if(NUBE_AWS){
          this.entidades =  JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
        } else {
          this.entidades = data
        }
      }, error => {
        console.log(error)
      })
  })
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
  guardar(){
    if(this.usuarioId.length > 0 && this.usuarioId != undefined && this.usuarioId[0].value != undefined){
      this.storages.get('companiasId').then((val) => {
        let companiaId = val
      let datosEntidades: entidades = {
        identificacion:this.identificacion,
        nombreEntidad:this.nombreEntidad,
        usuariosId:this.usuarioId[0].value,
        estado:this.estados == undefined || this.estados == '' ? 'A' : this.estados,
        direccion :this.direccion,
        telefonos :this.telefono,
        contacto:this.contacto,
        companiasId: companiaId,
        nombreTabla:'entidades',
        queHago: "I",
        name: "dataDynamicCrud"
      }
      if(this.nombreEntidad !== undefined && this.nombreEntidad != '') {
        this.storages.get('companiasId').then((val) => {
          datosEntidades['companiasId']  = val
        this.servicioCliente.guardarEntidades(datosEntidades)
          .subscribe(
          res => {
            this.utilidades.mensajeMuestro('Entidad','Guardado Exitosamente!','success')
            this.cargarServicio()
          }
           ,
          err => {
    
            console.log(err)}
          )
        })
      } else {
        this.utilidades.mensajeMuestro('Entidad','Existen campos obligatorios','advertencia')
      }

    })
    }else{
      this.utilidades.mensajeMuestro('Entidad','Debe seleccionar un usuario','success')
    }
  
  }

  editar(entidades){
    let modal = this.modalControllers.create(EntidadesEditarPage, { entidades })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {

        data.name = "dataDynamicCrud"
        data.entidadesId = entidades.entidadesId
        data.queHago = "A"
        data.nombreTabla = "entidades"
        this.storages.get('companiasId').then((val) => {
          data['companiasId'] = val
            this.servicio.actualizar(data)
            .subscribe(
              res => {
                this.entidades = []
                this.utilidades.mensajeMuestro('Entidades','Modificado correctamente.','success')
                this.cargarServicio()
              },
              err => console.log(err)
            )
        })


      }
    })
  }

  eliminar(todo: any){
    this.utilidades.mensajeConfirmacionDos('Entidad','¿Está Seguro de borrar el registro?','question','Si','No')
    .then((loQuiereBorrar: boolean) => {
     if (loQuiereBorrar) {
       let entidades = []
       entidades['queHago'] = "E"
       entidades['name'] = "dataDynamicCrud"
       entidades['nombreTabla'] = "entidades"
       entidades['entidadesId'] = todo.entidadesId
       this.servicio.eliminarEntidades(entidades)
       .subscribe(
         res => {
           this.entidades = []
           this.utilidades.mensajeMuestro('Entidad','Eliminado Exitosamente','success')
           let entidades = []
           this.cargarServicio();
         },
         err => console.log(err)
       )
     }
     else {
       this.utilidades.mensajeMuestro('Entidad','No se eliminó el registro','warning')
     }
   })
  }
  async buscarUsuarioSelectPage() {

    this.actualizarestados(this.estado)
    const modal = await this.modalControllers.create(UsuarioSelectPage);
    await modal.present();
    modal.onDidDismiss(data => {
      if (data) {
        this.usuarioId.push({value:data.value, display:data.display})
        let usuario: valueDisplay[] = [{
          value:data.value,
          display:data.display
        }]
        const actionUsuario = new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario);
        this.store.dispatch(actionUsuario);
        this.valoresUsuario = data.display;
      } 
    })
  }
  actualizarestados(estado: Estados) {
    let estados:any = {
      ...estado
    }
    let estadosAction = new fromEstados.SetEstadosAction(estados)
    this.store.dispatch(estadosAction)
  }

}



// WEBPACK FOOTER //
// ./src/pages/entidades-generales/entidades-generales.ts